module.exports = __webpack_public_path__ + "img/menu-arrow-down.1db9de09.png";